import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const ITEMS_PER_PAGE = 'commons.grid.pagination.itemsPerPage';
const NEXT_PAGE = 'commons.grid.pagination.nextPage';
const PREV_PAGE = 'commons.grid.pagination.previousPage';
const FIRST_PAGE = 'commons.grid.pagination.firstPage';
const LAST_PAGE = 'commons.grid.pagination.lastPage';

@Injectable()
export class MatPaginatorI18nService extends MatPaginatorIntl {
  private readonly translate = inject(TranslateService);

  constructor() {
    super();

    this.getAndInitTranslations();
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe(() => {
      this.getAndInitTranslations();
    });
  }

  public getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex: number = page * pageSize;
    const endIndex: number = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} / ${length}`;
  };

  public getAndInitTranslations(): void {
    this.translate.get([ITEMS_PER_PAGE, NEXT_PAGE, PREV_PAGE, FIRST_PAGE, LAST_PAGE]).subscribe((translation: Array<string>) => {
      this.itemsPerPageLabel = translation[ITEMS_PER_PAGE];
      this.nextPageLabel = translation[NEXT_PAGE];
      this.previousPageLabel = translation[PREV_PAGE];
      this.firstPageLabel = translation[FIRST_PAGE];
      this.lastPageLabel = translation[LAST_PAGE];

      this.changes.next();
    });
  }

}
